<template>
    <div class="partner bg_white">
        <div class="header">
            <button type="create" class="fr" @click="createEvent">新建</button>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @deleteEvent="deleteEvent"></lists>
        <create ref="create" @updateData="$refs.lists.updateData()"></create>
    </div>
</template>
<!--
-->
<script>
    import Lists from '@/components/Lists'
    import Create from './create'

    export default {
        name: "agent",
        components: {
            Lists, Create
        },
        data() {
            return {
                lists: {
                    title: [{text: '姓名'}, {text: '手机号'}, {text: '微信名称'}, {text: 'openid'}, {text: '抽成比例(%)'}, {text: '状态'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '15%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '20%', textAlign: 'left'},
                    {width: '15%', textAlign: 'center'},
                    {width: '10%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/partner',
                    func: this.httpRequestHandle,
                    error: '获取合伙人信息出错',
                    auto: false
                },
            }
        },
        methods: {
            init() {
                this.$refs.lists.updateData();
            },
            httpRequestHandle(data) {
                let operation = {
                    arr: [
                        {text: '删除', style: {color: '#FF2118'}, event: 'deleteEvent'},
                        // {text: '同意注册', style: {color: '#1890FF'}, event: 'agreeEvent'},
                    ]
                };
                return data.map(item =>{
                    return [
                        {text: item.name},
                        {text: item.phone},
                        // {text: item.wechat},
                        // {text: item.openid},
                        {text: '-------------'},
                        {text: '-------------'},
                        {text: item.commission},
                        {text: this.$config.partnerStatus.get(item.status)},
                        operation
                    ]
                });
            },
            createEvent() {
                this.$refs.create.init();
            },
            deleteEvent(data) {
                this.$delete({
                    title: '删除合伙人',
                    tooltipContent: '请输入当前合伙人名称以删除当前合伙人,数据将不可恢复，谨慎操作',
                    value: data.name,
                    confirm: () => {
                        this.$api.delete('/manage/partner/' + data.id).then((data) => {
                            this.$alert.success({content: '删除合伙人成功'});
                            this.$refs.lists.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '删除合伙人失败'});
                        });
                    }
                })
            },
            agreeEvent() {

            }
        }
    }
</script>

<style scoped>
    .partner {
        padding: 0 5px;
    }

    .partner > .header {
        height: 80px;
        padding: 0 15px;
    }

    .partner > .header > button {
        margin-top: 20px;
    }
</style>